export default __webpack_public_path__ + "static/media/icon-unauthorized.da4534d3.svg";